import { useSignal } from "@preact/signals";
import { invoke } from "$store/runtime.ts";
import type { JSX } from "preact";

type Errors =
  | "empty-name"
  | "empty-email"
  | "invalid-email"
  | "unexpected-error";

export default function Form() {
  const loading = useSignal(false);
  const errors = useSignal<Errors[]>([]);

  function validateForm(name?: string, email?: string): Errors[] {
    return [
      !name && "empty-name",
      !email && "empty-email",
      email && !email.match(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      ) && "invalid-email",
    ].filter(Boolean) as Errors[];
  }

  const handleSubmit: JSX.GenericEventHandler<HTMLFormElement> = async (
    event,
  ) => {
    event.preventDefault();

    const { target } = event;
    const form = target as HTMLFormElement;
    const { name, email } = Object.fromEntries(new FormData(form).entries());
    errors.value = validateForm(name.toString(), email?.toString());

    if (errors.value.length) return;

    try {
      await invoke.vtex.actions.newsletter.subscribe({
        name: name.toString(),
        email: email.toString(),
      });

      const newsletter = document.querySelector("#newsletter");
      newsletter?.setAttribute("data-success", "true");
    } catch (error) {
      console.error(error);
      errors.value = ["unexpected-error"];
    }
  };

  return (
    <>
      <form
        class="mt-6 grid gap-6 lg:relative lg:gap-9"
        onSubmit={handleSubmit}
      >
        <div class="grid gap-1">
          <label
            class="text-tw-neutral-500 font-medium"
            htmlFor="newsletter-name"
          >
            Digite seu nome
          </label>

          <input
            id="newsletter-name"
            class={`h-12 px-3 border rounded-lg bg-white ${
              errors.value.includes("empty-name")
                ? "border-tw-danger-200 placeholder:text-tw-danger-200"
                : "border-tw-primary-100 placeholder:text-tw-neutral-400"
            }`}
            name="name"
            type="text"
            placeholder={errors.value.includes("empty-name")
              ? "Digite um nome"
              : "Ex: Seu nome"}
            onChange={() =>
              errors.value = errors.value.filter((error) =>
                error !== "empty-name"
              )}
          />
        </div>

        <div class="grid gap-1">
          <label
            class="text-tw-neutral-500 font-medium"
            htmlFor="newsletter-email"
          >
            Digite seu e-mail
          </label>

          <input
            id="newsletter-email"
            class={`h-12 px-3 border rounded-lg bg-white ${
              errors.value.includes("empty-email") ||
                errors.value.includes("invalid-email")
                ? "border-tw-danger-200 placeholder:text-tw-danger-200"
                : "border-tw-primary-100 placeholder:text-tw-neutral-400"
            }`}
            name="email"
            type="text"
            placeholder={errors.value.includes("empty-email")
              ? "Digite um e-mail"
              : "Ex: seuemail@seuemail.com.br"}
            onChange={() =>
              errors.value = errors.value.filter((error) =>
                error !== "empty-email"
              ).filter((error) => error !== "invalid-email")}
          />
        </div>

        <button
          class="h-12 rounded-lg bg-tw-primary-100 text-white text-xl font-bold transition-colors hover:bg-tw-primary-200 lg:w-[11rem] lg:absolute lg:bottom-0 lg:right-0"
          disabled={loading.value}
        >
          Cadastrar
        </button>
      </form>

      {errors.value.includes("unexpected-error") && (
        <p class="max-w-xs mt-5 mx-auto text-tw-danger-100 font-bold text-center">
          Ocorreu um erro inesperado. Tente novamente mais tarde.
        </p>
      )}
    </>
  );
}
